import { LocationQueryValue } from 'vue-router'

type QueryValue = LocationQueryValue | LocationQueryValue[]

export const parseNumericQueryParam = (param: QueryValue) => {
  if (typeof param !== 'string') return

  const castValue = Number(param)

  if (isNaN(castValue)) return

  return castValue
}

export function castStringifiedBoolean(value: 'true' | 'false') {
  return value === 'true' ? true : false
}

export function transformKeysFromCamelToSnakeCase(
  props: Record<string, unknown>,
) {
  return Object.entries(props).reduce(
    (accumulator, [key, value]) => {
      key = key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)

      accumulator[key] = value
      return accumulator
    },
    {} as Record<string, unknown>,
  )
}

export function parseFormFields(formFields: string | null) {
  if (!formFields) return {}
  return JSON.parse(formFields)
}

export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms))

export function parseISOWithoutTimezone(timestamp: string) {
  return parseISO(timestamp.replace(/([+-]\d{2}:\d{2}|Z)$/, ''))
}

export function safeJSON<T = Record<PropertyKey, unknown>>(
  guard?: (o: unknown) => o is T,
): (text: string) => T | null {
  return function (text: string): T | null {
    try {
      const parsed = JSON.parse(text)

      if (typeof guard === 'function' && !guard(parsed)) {
        throw new Error('Failed to parse')
      }

      return parsed as T
    } catch {
      return null
    }
  }
}

export function stripHtml(html: string) {
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return doc.body.firstElementChild?.tagName.toLowerCase() !== 'style'
    ? doc.body.firstElementChild?.textContent
    : doc.body.firstElementChild?.nextElementSibling?.textContent
}
